<template>
    <input type="tel"
           id="phone_number"
           ref="cell_number"
           name="phone_number"
           placeholder="Enter Phone Number"
           @keyup="formatIntlTelInput()">
</template>
<script>

require('jquery-input-mask-phone-number');
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'intl-tel-input/build/js/utils.js';

export default {

    props: ['value'],

    data() {
        return {
            isValid: false,
            phoneInput: null,
            number: this.value,
        }
    },

    mounted() {

        const input = this.$refs.cell_number
        this.phoneInput = intlTelInput(input, {
            separateDialCode: false,
            formatOnDisplay: true,
            // initialCountry: "auto",
            utilsScript: '/js/in-tel-utils.js',
            geoIpLookup: (callback) => {
                fetch("https://ipapi.co/json")
                    .then(response => { return response.json(); })
                    .then(response => {
                        console.log(response)
                        callback(response.country_code);
                    })
                    .catch(() => { callback("us"); });
            }
        });
        if (this.number) {
            this.phoneInput.setNumber(this.number)
            var iti = window.intlTelInputGlobals.getInstance(input);
            this.phoneInput.setCountry(iti.getSelectedCountryData().iso2)
        }

        this.updateValid()

        input.addEventListener("countrychange", event => {
            var iti = window.intlTelInputGlobals.getInstance(input);
            this.phoneInput.setCountry(iti.getSelectedCountryData().iso2)
            this.formatIntlTelInput()
        });

        input.addEventListener('blur', () => this.$emit('blur'))
    },

    methods: {
        formatIntlTelInput() {
            if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
                var currentText = this.phoneInput.getNumber();
                console.log(currentText)
                if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                    this.phoneInput.setNumber(currentText); // will autoformat because of formatOnDisplay=true
                    this.$emit('input', currentText)
                }
                this.updateValid()
            }
        },

        updateValid() {
            this.isValid = this.phoneInput.isValidNumber();
            this.$emit('validation', this.isValid)
        }
    },

    watch: {
        value() {
            this.number = this.value
        }
    }
}
</script>
